import Vue from 'vue'
import Router from 'vue-router'
import Login from './views/Login.vue'
import ExchangeToken from './views/ExchangeToken'
import Profile from './views/Profile'
import Home from './views/Home'
import Events from './views/Events'
import Webhook from './views/Webhook'
import EventDetail from '@/views/EventDetail'
import EventDashboard from '@/views/EventDashboard'
import TeamEventDashboard from '@/views/TeamEventDashboard'
import RoundCounter from '@/views/RoundCounter'
import RoundCounterDashboard from '@/views/RoundCounterDashboard'
import EventVar from '@/views/EventVar'
import EventMap from '@/views/EventMap.vue'
import TrainingPlan from '@/views/TrainingPlan.vue'
import MakeKorlor from '@/views/MakeKorlor.vue'
import Feed from '@/views/Feed.vue'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
      meta: {
        'title': 'Home'
      }
    },
    {
      path: '/events',
      name: 'events',
      component: Events,
      meta: {
        'title': 'Events'
      }
    },
    {
      path: '/event/:slug',
      name: 'eventDetail',
      component: EventDetail,
      meta: {
        'title': 'Event Detail'
      }
    },
    {
      path: '/event-dashboard/:slug',
      name: 'eventDashboard',
      component: EventDashboard,
      meta: {
        'title': 'Event Dashboard'
      }
    },
    {
      path: '/team-event-dashboard/:slug',
      name: 'teamEventDashboard',
      component: TeamEventDashboard,
      meta: {
        'title': 'Team Event Dashboard'
      }
    },
    {
      path: '/login',
      name: 'login',
      component: Login,
      meta: {
        'title': 'Login'
      }
    },
    {
      path: '/webhook',
      name: 'webhook',
      component: Webhook
    },
    {
      path: '/exchange-token',
      name: 'exchangeToken',
      component: ExchangeToken
    },
    {
      path: '/profile',
      name: 'profile',
      component: Profile,
      meta: {
        'title': 'Profile'
      }
    },
    {
      path: '/round-counter/:slug',
      name: 'roundCounter',
      component: RoundCounter,
      meta: {
        'title': 'RoundCounter'
      }
    },
    {
      path: '/round-counter-dashboard/:slug',
      name: 'roundCounterDashboard',
      component: RoundCounterDashboard,
      meta: {
        'title': 'RoundCounterDashboard'
      }
    },
    {
      path: '/event-var/:event_slug',
      name: 'eventVar',
      component: EventVar,
      meta: {
        'title': 'Event Var'
      }
    },
    {
      path: '/event-map/:slug',
      name: 'eventMap',
      component: EventMap,
      meta: {
        'title': 'Event Visual Map'
      }
    },
    {
      path: '/training-plan',
      name: 'trainingPlan',
      component: TrainingPlan,
      meta: {
        'title': 'Training Plans'
      }
    },
    {
      path: '/make-korlor',
      name: 'makeKorlor',
      component: MakeKorlor,
      meta: {
        'title': 'GPX 3D Animator'
      }
    },
    {
      path: '/feed',
      name: 'feed',
      component: Feed,
      meta: {
        'title': 'Activity Feed'
      }
    }
  ]
})

// Track page views on route change
router.afterEach((to) => {
  // Only track if gtag is available
  if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
    // Use nextTick to ensure DOM is updated
    Vue.nextTick(() => {
      // Send page_view event instead of config to avoid cookie overwrites
      window.gtag('event', 'page_view', {
        page_path: to.fullPath,
        page_title: to.meta.title || document.title,
        page_location: window.location.href
      })
    })
  }
})

export default router

// Add this import near the top with other imports
// import ProgressDemo from './views/ProgressDemo.vue'

// Then add this route in your routes array:
/*
{
  path: '/progress-demo',
  name: 'progressDemo',
  component: ProgressDemo
}
*/
